
define('text!views/shared/bullet_nav/bullet_nav.html',[],function () { return '<% for (var i = 0; i < this.bulletCount; i++) { %>\r\n    <a class="bullet-nav__bullet js-nav-bullet" data-bullet-index="<%- i %>"></a>\r\n<% } %>';});

